import Chevron from "components/Chevron"
import Link from "next/link"
import PageSection from "../page-section/PageSection"
import styles from './Link.module.css'

const TermsAndCondtions = () => {
    return (
      <PageSection>
        <Link href="/terms-and-conditions">
          <div className={`${styles.linkContainer} ${styles.linkPadding}`}>
            <p className={styles.linkLabel}>Terms & Conditions</p>
            <Chevron direction={'right'} />
          </div>
        </Link>
      </PageSection>
    );
}

export default TermsAndCondtions;